import { Link } from 'react-router-dom';

import { Button, EmptyState } from '../ui/index.js';
import { useAuth, roleHome } from '../lib/auth.js';
import { Logo } from './Logo.js';
import { OfflineBanner } from './OfflineBanner.js';

/** A friendly 404 shown for any unknown path. */
export function NotFound() {
  const { me } = useAuth();
  const home = me ? roleHome(me.role) : '/';
  return (
    <div className="pt-shell">
      <OfflineBanner />
      <header className="pt-topnav">
        <div className="pt-topnav__inner">
          <Logo />
        </div>
      </header>
      <main className="pt-shell__main">
        <EmptyState
          icon="search"
          title="We could not find that page"
          body="The link might be old, or the page moved somewhere else."
          action={
            <Link to={home}>
              <Button>Go home</Button>
            </Link>
          }
        />
      </main>
    </div>
  );
}
